export default __webpack_public_path__ + "static/media/brain.a1faa932.png";